export const DONASWAP_BNB_LP_MAINNET = '0xfc1C0387fcEeB92F59059e602Eb7683377C6b443'
